<div class="hello-band py-4">
	<div class="container">
		<div class="row">
			<div class="col-12 pt-1">
				<h1>Je wachtwoord (opnieuw) instellen</h1>
			</div>
		</div>
	</div>
</div>
<div class="container py-5">
	<section *ngIf="currentUser != false">
		<div class="container">
			Je bent al ingelogd!
		</div>
	</section>
	<section *ngIf="currentUser == false">
		<div *ngIf="!linkValid">
			<div class="alert alert-success" *ngIf="successRecovery">
				Er is een e-mail naar <em>{{email}}</em> onderweg met een link om je wachtwoord opnieuw in te stellen.
			</div>
			<ng-container *ngIf="showInvalidMessage">
				<div class="pb-3">{{invalidMsg}}</div>
				<button (click)="requestPasswordRecovery()" class="btn btn-success">
					<span>Nieuw wachtwoord aanvragen</span>
				</button>
			</ng-container>
		</div>
		<div *ngIf="linkValid">

			<div class="alert alert-success" *ngIf="successmessage">
				Yes! Je wachtwoord is ingesteld, je kunt nu hierboven inloggen.
			</div>
			<div class="alert alert-danger" *ngIf="errormessage">Er zijn enkel fouten gevonden.</div>

			<div *ngIf="!successmessage">
				<p>Vul hieronder je gloednieuwe wachtwoord in, daarna kun je met je e-mailadres en dit
					wachtwoord inloggen.</p>
				<div class="form-group">
					<label for="email">Nieuw wachtwoord</label>
					<input type="password" class="form-control" [(ngModel)]="password" (keyup.enter)="save()"
						(keyup)="checkPassword($event)"
						[ngClass]="{ 'is-invalid': errorPasswordRequired || errorInvalidPassword, 'is-valid': passwordValid }"
						value="{{password}}" />

					<div *ngIf="errorPasswordRequired" class="invalid-feedback">
						Je wachtwoord is verplicht.
					</div>
					<div *ngIf="errorInvalidPassword" class="invalid-feedback">
						Dit lijkt geen kloppend wachtwoord te zijn, kijk eens goed.
					</div>
					<div class="invalid-feedback" style="display:block;" *ngIf="errors.password">{{errors.password}}
					</div>
				</div>
				<div class="form-group">
					<label for="email">Herhaal nieuw wachtwoord</label>
					<input type="password" class="form-control" [(ngModel)]="repeatPassword" value="{{repeatPassword}}"
						(keyup.enter)="save()" (keyup)="checkMatch($event)"
						[ngClass]="{ 'is-invalid': errorPasswordMatch, 'is-valid': passwordMatchValid }" />

					<div class="invalid-feedback" *ngIf="errors.repeatPassword">{{errors.repeatPassword}}</div>
					<div *ngIf="errorPasswordMatch" class="invalid-feedback">
						Wachtwoorden komen niet overeen, kijk eens goed.
					</div>
				</div>

				<button (click)="save()" class="btn btn-success">
					<span>Wachtwoord opslaan</span>
				</button>
			</div>
		</div>
	</section>
</div>